import {renderTextHighlight} from './m-highlight';
/**
 * 
 * @param {mTextHighlight} highlight 
 */
export function doHighlight(highlight){
    console.log("[@cruxcode/testpdfviewer] doHighlight", highlight);
    renderTextHighlight(highlight).then(()=>{
        console.log("[@cruxcode/testpdfviewer] highlight success");
    }).catch(()=>{console.log("[@cruxcode/testpdfviewer] highlight error")});
}

export function drawSvg(data){
    console.log("[@cruxcode/testpdfviewer] doHighlight");
}